import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell, { authInputClass } from "./AuthShell";
import { useAuth } from "./AuthContext";

const LoginPage = () => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { requestLoginCode } = useAuth();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (phone.length !== 11) {
      setError("لطفا شماره موبایل 11 رقمی وارد کنید");
      return;
    }

    setLoading(true);
    try {
      await requestLoginCode(phone);
      navigate("loginVerify");
    } catch (requestError) {
      setError(
        requestError.response?.status === 423
          ? "لطفا بعدا تلاش کنید"
          : "شماره تلفن موجود نیست"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="ورود"
      altLabel="ثبت نام"
      altTo="/Signup"
      errors={[error]}
      loading={loading}
      submitLabel="تایید"
      onSubmit={handleSubmit}
    >
      <input
        name="phone"
        type="tel"
        inputMode="numeric"
        autoComplete="tel"
        placeholder="تلفن خود را وارد کنید"
        className={authInputClass}
        value={phone}
        onChange={(event) => setPhone(event.target.value)}
        autoFocus
        required
      />
    </AuthShell>
  );
};

export default LoginPage;
